import React, { Component } from 'react';

import 'idempotent-babel-polyfill';
import renderHTML from 'react-render-html';
import { backgroundImage, get_json ,imagePath} from './common';
import { connect } from 'react-redux'
import Loader from './Loader'
// import { withRouter } from 'react-router';
import { withRouter, Link } from "react-router-dom";

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = { data: [], open: "" };
	}
	async componentDidMount() {
		if (this.props.alldata === null) {
			await get_json(this)
			this.props.setresponseJson(this.state.data)

		} else {
			await this.setState({ data: this.props.alldata })

		}
		if (typeof this.state.data !== 'undefined') {
			this.setState({ phone: this.state.data.phone, email: this.state.data.email, location: this.state.data.location, logo_image: this.state.data.logo_image, site_title: this.state.data.site_title });
		}

		let Socialicons = [];
		if (typeof this.state.data.social_json !== 'undefined') {
			let social = JSON.parse(this.state.data.social_json);
			if (Object.keys(social).length > 0) {
				social.map((item, i) => {
					if (item.type == 'facebook') {
						var icon = 'fa fa-facebook';
						var class_name = 'facebook';
					} else if (item.type == 'twitter') {
						var icon = 'fa fa-twitter';
						var class_name = 'twitter';
					} else if (item.type == 'instagram') {
						var icon = 'fa fa-instagram';
						var class_name = 'instagram';
					} else if (item.type == 'linkedin') {
						var icon = 'fa fa-linkedin';
						var class_name = 'linkedin';
					}
					Socialicons.push(
						<li key={i}><a href={item.url} className={`${class_name}`} target="_blank">
							<div className="front"><i className={`${icon}`} aria-hidden="true"></i></div>

						</a></li>
					);
				});
				this.setState({ Socialicons: Socialicons });
				localStorage.setItem('Socialicons', JSON.stringify(this.state.Socialicons));
			}
		}

		let menu_item = [];
		let header = this.state.data.header;
		if (typeof header !== 'undefined') {
			if (header.length > 0) {
				header.forEach((item, i) => {
					if (item.page_link === 'Home') {
						var class_name = 'menu__item--current';
						var page_link = '/';
					} else {
						page_link = item.page_link;
					}
					menu_item.push(
						<li className={`menu__item ${class_name}`} key={i}>
							<Link to={page_link} className="dropdown-toggle menu__link">{item.page_title}</Link>
						</li>

					);
				});
				this.setState({ menu_item: menu_item });
			}
		}
		var footer = this.state.data['footer'];
		if (typeof footer !== 'undefined') {
			this.setState({ footer_content: footer.footer_content });
		}
	}
	render() {
		return (
			<footer className="footer w-left">
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-5 footr_col footer-left">
							<div className="logo_img">
								<Link to='/'>
									{this.state.logo_image !== "" ? <img className="logo_image" src={imagePath+this.state.logo_image} alt="Awesome" /> : <p>{this.state.site_title}</p>}
								</Link>
							</div>
							<p className="footer_sec_content">PC Jeweller has a variety of collection specially selected for all gender and for people of all ages.</p>

						</div>
						<div className="col-sm-12 col-md-3 footr_col sign-gd">
							<h4 className="hidden-xs">Quick <span>Links</span></h4>
							<h4 className={`footer_link visible-xs ${this.state.open === "Links" && "showed"}`} onClick={() => this.setState({ open: this.state.open === "Links" ? "" : "Links" })}>Quick <span>Links</span></h4>
							<ul className="footerCont" style={{ display: this.state.open === "Links" ? "block" : '' }}>
								<li className="menu__item menu__item--current"><a className="menu__link" onClick={()=>{ this.props.history.push("/")}}>Home</a></li>
								<li className="menu__item"><a className="menu__link" onClick={()=>{ this.props.history.push("/about")}}>About us</a></li>
								<li className="menu__item"><a className="menu__link" onClick={()=>{ this.props.history.push("/contact")}}>Contact us</a></li>
								<li className="menu__item"><a className="menu__link" onClick={()=>{ this.props.history.push("/gallery")}}>Gallery</a></li>
								<li className="menu__item"><a className="menu__link" onClick={()=>{ this.props.history.push("/blog")}}>Blog</a></li>
							</ul>
						</div>
						<div className="col-sm-12 col-md-4 footr_col sign-gd-two">
							<h4 className="hidden-xs">Store <span>Information</span></h4>
							<h4 className={`footer_link visible-xs ${this.state.open === "Store" && "showed"}`} onClick={() => this.setState({ open: this.state.open === "Store" ? "" : "Store" })}>Store <span>Information</span></h4>
							<div className="w3-address footerCont" style={{ display: this.state.open === "Store" ? "block" : '' }}>
								<div className="w3-address-grid">
									<div className="w3-address-left"><i className="fa fa-phone" aria-hidden="true" /></div>
									<div className="w3-address-right">
										<h6>{this.state.phone}</h6>
									</div>
								</div>
								<div className="w3-address-grid">
									<div className="w3-address-left"><i className="fa fa-envelope" aria-hidden="true" /></div>
									<div className="w3-address-right">
										<a href="mailto:example@email.com">{this.state.email}</a>
									</div>
								</div>
								<div className="w3-address-grid">
									<div className="w3-address-left"><i className="fa fa-map-marker" aria-hidden="true" /></div>
									<div className="w3-address-right">
										<h6>{this.state.location}</h6>
									</div>
								</div>
							</div>
						</div>
					</div>
					<h6 className="copy-right">
						{renderHTML(`${this.state.footer_content}`)}
					</h6>
				</div>
			</footer>

		)
	}

}
const mapStateToProps = (state) => {
	return {
		alldata: state.responseJson,

	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Footer));

